import type { Form } from 'payments-lib-types';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormGroup } from '@/components/form/groups/FormGroup';
import { Input } from '@/components/form/Input';
import type { OfUnion } from '@/types/common';
import type { MethodField } from '../helpers';

export const FieldPassword: FC<
  OfUnion<MethodField>[Form.MethodFieldType.Password]
> = ({ fieldName, activeThemeMode }) => {
  const { t } = useTranslation('common');

  return (
    <FormGroup
      mode={activeThemeMode}
      title={t('auth.registration.form.password')}
    >
      <Input
        mode={activeThemeMode}
        name={fieldName}
        placeholder={t('auth.registration.form.password')}
        type="password"
      />
    </FormGroup>
  );
};
